// import ReactGA from "react-ga4";
// import { useEffect } from "react";
import { Navigate, Routes, Route, useParams } from "react-router-dom";
// 그룹 및 프로젝트 권한 검사 라우트
import ProtectedRoute from "./ProtectedRoute";
import GroupGuard from "./GroupGuard";
import ProjectGuard from "./ProjectGuard";

// 랜딩 페이지 컴포넌트
import LandingPage from "../components/Landing/LandingPage";
// 로그인 페이지 컴포넌트
import LoginPage from "../components/Login/LoginPage";
// DT 화면 조회 페이지 컴포넌트
import SfvPage from "../components/SfvPage/SfvPage";
import SfvLePage from "../components/SfvPage/sfvLePage";
import SVPage from "../components/SfvPage/SVPage";
import LEPage from "../components/SfvPage/LEPage"; // 웹 레이아웃 편집

// 테마 컴포넌트
import ThemeComponent from "../themes/ThemeComponent";

// 관리자 페이지 컴포넌트
import GroupsPage from "../components/Groups/GroupsPage";

// 프로젝트 레이아웃 컴포넌트
import ProjectAppLayout from "../layouts/ProjectAppLayout";
import MasterAppLayout from "../layouts/MasterAppLayout";
import MobileAppLayout from "../layouts/MobileAppLayout";
import ProjectEditLayout from "../layouts/ProjectEditLayout";
import SafeAppLayout from "../layouts/SafeAppLayout";
import ApsAppLayout from "../layouts/ApsAppLayout";

import QrPage from "../components/Mobile/QrPage";
import QrScanPage from "../components/Mobile/QrPage/QrScanPage";
import ChecklistPage from "../components/Mobile/ChecklistPage";
import MobileTempPage from "../components/Mobile/MobileMainPage/mobileTemp";

import UsersPage from "../components/Users/UserPage";
import ProjectPage from "../components/Projects/ProjectPage";
import MachineStatusPage from "../components/Projects/Edit/MachineStatus";
import StatusMasterPage from "../components/Projects/Edit/StatusMaster";
import FileManagementPage from "../components/Projects/Edit/FileManagement";

import MasterPage from "../components/Master";
import ItemMasterPage from "../components/Master/itemMasterPage";
import WorkerMasterPage from "../components/Master/workerMasterPage";

import { RiskAssessmentMain } from "../components/RISK_ASSESSMENT/pages/main";
import { StandardProcess } from "../components/RISK_ASSESSMENT/pages/standard/process";
import { StandardMachine } from "../components/RISK_ASSESSMENT/pages/standard/machine";
import { StandardSituation } from "../components/RISK_ASSESSMENT/pages/standard/situation";
import { StandardCriteriaTable } from "../components/RISK_ASSESSMENT/pages/standard/criteriaTable";
import { StandardSafetyRegulations } from "../components/RISK_ASSESSMENT/pages/standard/safetyRegulations";
import { StandardScenario } from "../components/RISK_ASSESSMENT/pages/standard/scenario";
import { StandardEmployee } from "../components/RISK_ASSESSMENT/pages/standard/employee";
import { StandardMsdsManagement } from "../components/RISK_ASSESSMENT/pages/standard/msds";
import { StandardLocationManagement } from "../components/RISK_ASSESSMENT/pages/standard/location";
import { RegisterMachine } from "../components/RISK_ASSESSMENT/pages/register/machine";
import { RegisterCause } from "../components/RISK_ASSESSMENT/pages/register/cause";
import { RegisterStatus } from "../components/RISK_ASSESSMENT/pages/register/status";
import { AssessmentLevel } from "../components/RISK_ASSESSMENT/pages/assessment/level";
import { AssessmentResult } from "../components/RISK_ASSESSMENT/pages/assessment/result";
import { AssessmentStatus } from "../components/RISK_ASSESSMENT/pages/assessment/status";
import { RiskAssessmentWizard } from "../components/RISK_ASSESSMENT/pages/assessment/wizard";
import {
  AssessmentStep1Page,
  AssessmentStep2Page,
  AssessmentStep3Page,
} from "../components/RISK_ASSESSMENT/pages/assessment/steps";
import { StrategyRegister } from "../components/RISK_ASSESSMENT/pages/strategy/register";
import { StrategyResult } from "../components/RISK_ASSESSMENT/pages/strategy/result";
import { MonitoringResult } from "../components/RISK_ASSESSMENT/pages/monitoring/result";
import { MonitoringStrategy } from "../components/RISK_ASSESSMENT/pages/monitoring/strategy";
import { MonitoringReport } from "../components/RISK_ASSESSMENT/pages/monitoring/report";
import { TbmManagement } from "../components/RISK_ASSESSMENT/pages/monitoring/tbm";
import { EducationScheduleManagement } from "../components/RISK_ASSESSMENT/pages/monitoring/education";
import { SafetyInspectionManagement } from "../components/RISK_ASSESSMENT/pages/monitoring/inspection";
import { IntegratedReportGenerator } from "../components/RISK_ASSESSMENT/pages/monitoring/integratedReport";
import { WorkerHazardProposal } from "../components/RISK_ASSESSMENT/pages/worker/hazardProposal";
import { WorkerHazardProposalReview } from "../components/RISK_ASSESSMENT/pages/worker/hazardReview";
import { AdminActionInbox, WorkerActionInbox } from "../components/RISK_ASSESSMENT/pages/worker/actionInbox";

// APS 페이지
import Plan from "../components/APS/Plan/Plan";
import AiGantt from "../components/APS/AiGantt";
import Performance from "../components/APS/Performance";
import LearningViewer from "../components/APS/Learning";
import MachineMaster from "../components/APS/MchMaster";
import InformationForViewer from "../components/APS/Information/InformationForViewer";
import FactoryManagement from "../components/APS/Operation";

// 일정계획 페이지
import PlanAppLayout from "../layouts/PlanAppLayout";
import PlanPlan from "../components/PLANNING/Plan/Plan";
import AiGanttPlan from "../components/PLANNING/AiGantt";
import InformationPlan from "../components/PLANNING/Information/InformationForViewer";
import MachineMasterPlan from "../components/PLANNING/MchMaster";
import Graph from "../components/PLANNING/Graph";
import AdminSettings from "../components/PLANNING/Admin";
import FactoryManagementPlan from "../components/PLANNING/Operation";
import PlanCalendar from "../components/PLANNING/Calendar";
import PlanMaterial from "../components/PLANNING/Material";
import PlanBomManagement from "../components/PLANNING/BOM";
import PlanStock from "../components/PLANNING/Stock";
import PlanInOut from "../components/PLANNING/InOut";
import PlanResultGrid from "../components/PLANNING/ResultGrid";
import PlanItemMaster from "../components/PLANNING/ItemMaster";
import PlanCustomSettings from "../components/PLANNING/CustomSettings";
import PlanTempStock from "../components/PLANNING/TempStock";

// TPC 계획 페이지
import TpcPlanLayout from "../layouts/TpcPlanLayout";
import TpcPlanMain from "../components/TPC/main";
import Processed from "../components/TPC/Processed";
import ImportLog from "../components/TPC/Log";
import KpiPage from "../components/TPC/KPI";
import TpcMachineMaster from "../components/TPC/MchMaster";
import TpcInformationForViewer from "../components/TPC/Information/InformationForViewer";
import TpcFactoryManagement from "../components/TPC/Operation";
import TpcPlan from "../components/TPC/Plan/Plan";
import TpcBomManagement from "../components/TPC/BOM";
import TpcMaterial from "../components/TPC/Material";
import TpcresultGrid from "../components/TPC/ResultGrid";
import TpcStock from "../components/TPC/Stock";
import TpcCustomSettings from "../components/TPC/CustomSettings";
import TpcAdmin from "../components/TPC/Admin";
import TpcGantt from "../components/TPC/AiGantt";
import TpcWorkOrder from "../components/TPC/WorkOrder";
import TpcWorkOrderLog from "../components/TPC/WorkOrderLog";
import TpcChangeover from "../components/TPC/Changeover";
import TpcShift from "../components/TPC/Shift";
import TpcTempStock from "../components/TPC/TempStock";
import TpcStockInfo from "../components/TPC/StockInfo";
import Simulation from "../components/TPC/Simulation";
import WorkOrderRegister from "../components/TPC/WorkOrderRegister";

const SafeStrategyScheduleRedirect = () => {
  const { group_code, project_code } = useParams();
  return (
    <Navigate
      to={`/safe/${group_code}/${project_code}/strategy/result`}
      replace
    />
  );
};

const SafeAssessmentStep4Redirect = () => {
  const { group_code, project_code } = useParams();
  return (
    <Navigate
      to={`/safe/${group_code}/${project_code}/assessment/wizard/step-3`}
      replace
    />
  );
};

const SafeDesktopOnlyRoute = ({ children }) => {
  const { group_code, project_code } = useParams();
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 899.95px)").matches;

  if (isMobile) {
    return <Navigate to={`/safe/${group_code}/${project_code}`} replace />;
  }

  return children;
};

function AllRoute() {
  // const location = useLocation();

  // Google Analytics 설정
  // useEffect(() => {
  //   ReactGA.send({ hitType: "pageview", page: location.pathname });
  // }, [location]);

  const darkSettings = { mode: "dark" };
  const lightSettings = { mode: "light" };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ThemeComponent settings={lightSettings}>
            <LandingPage />
          </ThemeComponent>
        }
      />

      {/* 그룹별 로그인 페이지 */}
      <Route
        path="/login/:groupcode"
        element={
          <ThemeComponent settings={darkSettings}>
            <LoginPage />
          </ThemeComponent>
        }
      />

      {/* 관리자 관리 페이지 */}
      <Route
        path="/admin"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <ProjectAppLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        <Route path="groups" element={<GroupsPage />} />
      </Route>

      {/* /projects 경로 */}
      <Route
        path="/projects"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <ProjectAppLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        {/* /projects 기본 페이지 */}
        <Route index element={<ProjectPage />} />
      </Route>

      {/* /users 경로 */}
      <Route
        path="/users"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <ProjectAppLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        <Route index element={<UsersPage />} />
      </Route>

      {/* 마스터 데이터 관리 */}
      <Route
        path="/master"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <MasterAppLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        <Route
          path="machine/:group_code/:project_code"
          element={
            <GroupGuard>
              <ProjectGuard systemType="MASTER">
                <MasterPage />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path="item/:group_code/:project_code"
          element={
            <GroupGuard>
              <ProjectGuard systemType="MASTER">
                <ItemMasterPage />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path="worker/:group_code/:project_code"
          element={
            <GroupGuard>
              <ProjectGuard systemType="MASTER">
                <WorkerMasterPage />
              </ProjectGuard>
            </GroupGuard>
          }
        />
      </Route>

      <Route
        path="/safe-worker/:group_code/:project_code/hazard-proposal"
        element={
          <ThemeComponent settings={lightSettings}>
            <WorkerHazardProposal />
          </ThemeComponent>
        }
      />
      <Route
        path="/safe-worker/:group_code/:project_code/action-inbox"
        element={
          <ThemeComponent settings={lightSettings}>
            <WorkerActionInbox />
          </ThemeComponent>
        }
      />

      {/* 안전관리 시스템 라우트 */}
      <Route
        path="/safe"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <SafeAppLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        {/* 정보관리 항목 */}
        <Route
          path=":group_code/:project_code"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <RiskAssessmentMain />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/process"
          // 공정등록 페이지
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardProcess />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/machine"
          // 설비기준정보 페이지
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardMachine />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/cause"
          // 위험발생상황 및 결과 페이지
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardSituation />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/criteriaTable"
          // 위험성 추정 기준표 페이지
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardCriteriaTable />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/safetyRegulations"
          // 안전보건 페이지
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardSafetyRegulations />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/scenario"
          // 비상사태 시나리오 페이지
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardScenario />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/employee"
          // 직원 정보 페이지
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardEmployee />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/msds"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardMsdsManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/location"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StandardLocationManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />

        <Route
          // 위험성평가 설비 등록 페이지
          path=":group_code/:project_code/register/machine"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <RegisterMachine />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 유해위험요인 등록 페이지
          path=":group_code/:project_code/register/cause"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <RegisterCause />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 유해위험요인 등록 현황 페이지
          path=":group_code/:project_code/register/status"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <RegisterStatus />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 위험성 수준 평가 페이지
          path=":group_code/:project_code/assessment/level"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <AssessmentLevel />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/assessment/wizard"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <SafeDesktopOnlyRoute>
                  <RiskAssessmentWizard />
                </SafeDesktopOnlyRoute>
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/assessment/wizard/step-1"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <SafeDesktopOnlyRoute>
                  <AssessmentStep1Page />
                </SafeDesktopOnlyRoute>
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/assessment/wizard/step-2"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <SafeDesktopOnlyRoute>
                  <AssessmentStep2Page />
                </SafeDesktopOnlyRoute>
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/assessment/wizard/step-3"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <SafeDesktopOnlyRoute>
                  <AssessmentStep3Page />
                </SafeDesktopOnlyRoute>
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/assessment/wizard/step-4"
          element={<SafeAssessmentStep4Redirect />}
        />
        <Route
          // 위험성 추정 결과 페이지
          path=":group_code/:project_code/assessment/result"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <AssessmentResult />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 위험성 평가 현황 페이지
          path=":group_code/:project_code/assessment/status"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <AssessmentStatus />
              </ProjectGuard>
            </GroupGuard>
          }
        />

        <Route
          // 위험성 감소대책 등록 페이지
          path=":group_code/:project_code/strategy/register"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StrategyRegister />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 위험성 감소대책 일정 관리 페이지
          path=":group_code/:project_code/strategy/schedule"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <SafeStrategyScheduleRedirect />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 개선실행 결과 관리 페이지
          path=":group_code/:project_code/strategy/result"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <StrategyResult />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 설비 위험성 평가 결과 페이지
          path=":group_code/:project_code/monitoring/result"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <MonitoringResult />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 대책수립 결과 페이지
          path=":group_code/:project_code/monitoring/strategy"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <MonitoringStrategy />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          // 위험성 평가 보고서 페이지
          path=":group_code/:project_code/monitoring/report"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <MonitoringReport />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/monitoring/tbm"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <TbmManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/monitoring/education"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <EducationScheduleManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/monitoring/inspection"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <SafetyInspectionManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/monitoring/actions"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <AdminActionInbox />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/monitoring/integrated-report"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <SafeDesktopOnlyRoute>
                  <IntegratedReportGenerator />
                </SafeDesktopOnlyRoute>
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/worker/hazard-proposal"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <WorkerHazardProposal />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/worker/hazard-review"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <WorkerHazardProposalReview />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/worker/action-inbox"
          element={
            <GroupGuard>
              <ProjectGuard systemType="SAFE">
                <WorkerActionInbox />
              </ProjectGuard>
            </GroupGuard>
          }
        />
      </Route>

      {/* 일정계획 시스템 라우트 */}
      <Route
        path="/aps"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <ApsAppLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        {/* AI 생산계획 항목 */}
        <Route
          path=":group_code/:project_code/plan"
          element={
            <GroupGuard>
              <ProjectGuard systemType="APS">
                <Plan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        {/* Gantt 차트 항목 */}
        <Route
          path=":group_code/:project_code/gantt"
          element={
            <GroupGuard>
              <ProjectGuard systemType="APS">
                <AiGantt />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        {/* 생산실적 항목 */}
        <Route
          path=":group_code/:project_code/performance"
          element={
            <GroupGuard>
              <ProjectGuard systemType="APS">
                <Performance />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        {/* 일정 계획 규칙 항목 */}
        <Route
          path=":group_code/:project_code/rule"
          element={
            <GroupGuard>
              <ProjectGuard systemType="APS">
                <LearningViewer />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        {/* 기준정보 항목 */}
        {/* 장비 관리 항목 */}
        <Route
          path=":group_code/:project_code/standard/machine"
          element={
            <GroupGuard>
              <ProjectGuard systemType="APS">
                <MachineMaster />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        {/* 아이템 관리 항목 */}
        <Route
          path=":group_code/:project_code/standard/item"
          element={
            <GroupGuard>
              <ProjectGuard systemType="APS">
                <InformationForViewer />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        {/* 가동시간 관리 항목 */}
        <Route
          path=":group_code/:project_code/standard/time"
          element={
            <GroupGuard>
              <ProjectGuard systemType="APS">
                <FactoryManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />
      </Route>

      {/* 생산계획 시스템 라우트 */}
      <Route
        path="/plan"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <PlanAppLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        {/* 메인 항목 */}
        <Route
          path=":group_code/:project_code"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanPlan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/planning"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanPlan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/gantt"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <AiGanttPlan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/item"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <InformationPlan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/item_m"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanItemMaster />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/machine"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <MachineMasterPlan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/graph"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <Graph />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/admin"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <AdminSettings />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/time"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <FactoryManagementPlan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/calendar"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanCalendar />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/bom_management"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanBomManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/material"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanMaterial />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/in_out"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanInOut />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/result"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanResultGrid />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/stock"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanStock />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/custom_settings"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanCustomSettings />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/sjh_stock_info"
          element={
            <GroupGuard>
              <ProjectGuard systemType="PLAN">
                <PlanTempStock />
              </ProjectGuard>
            </GroupGuard>
          }
        />
      </Route>

      {/* DT 화면 조회 */}
      <Route
        path="/insightwin/:group_code/:project_code"
        element={
          <ThemeComponent settings={darkSettings}>
            <ProtectedRoute>
              <GroupGuard>
                <ProjectGuard systemType="DT">
                  <SfvPage />
                </ProjectGuard>
              </GroupGuard>
            </ProtectedRoute>
          </ThemeComponent>
        }
      />

      {/* DT 화면 조회 (레이아웃 편집) */}
      <Route
        path="/insightwinLEDT/:group_code/:project_code"
        element={
          <ThemeComponent settings={darkSettings}>
            <ProtectedRoute>
              <GroupGuard>
                <ProjectGuard systemType="DT">
                  <SfvLePage />
                </ProjectGuard>
              </GroupGuard>
            </ProtectedRoute>
          </ThemeComponent>
        }
      />

      {/* DT 레이아웃 편집 */}
      <Route
        path="/insightwinLE/:group_code/:project_code"
        element={
          <ThemeComponent settings={darkSettings}>
            <ProtectedRoute>
              <GroupGuard>
                <ProjectGuard systemType="LAYOUT">
                  <LEPage />
                </ProjectGuard>
              </GroupGuard>
            </ProtectedRoute>
          </ThemeComponent>
        }
      />

      {/* DT SimView */}
      <Route
        path="/insightwinSV/:group_code/:project_code"
        element={
          <ThemeComponent settings={darkSettings}>
            <ProtectedRoute>
              <GroupGuard>
                <ProjectGuard systemType="SV">
                  <SVPage />
                </ProjectGuard>
              </GroupGuard>
            </ProtectedRoute>
          </ThemeComponent>
        }
      />

      {/* 프로젝트 에디트 */}
      <Route
        path="/edit"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <ProjectEditLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        <Route
          path="file/:group_code/:project_code"
          element={
            <GroupGuard>
              <FileManagementPage />
            </GroupGuard>
          }
        />
        <Route
          path="machinestatus/:group_code/:project_code"
          element={
            <GroupGuard>
              <MachineStatusPage />
            </GroupGuard>
          }
        />
        <Route
          path="statusmaster/:group_code/:project_code"
          element={
            <GroupGuard>
              <StatusMasterPage />
            </GroupGuard>
          }
        />
      </Route>

      {/* TPC 계획 페이지 */}
      <Route
        path="/tpcplan"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <TpcPlanLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        <Route
          path=":group_code/:project_code"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcPlan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/excel/processed"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <Processed />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/excel/excel_upload"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcPlanMain />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/excel/excel_log"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <ImportLog />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/kpi"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <KpiPage />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/machine"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcMachineMaster />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        {/* 아이템 관리 항목 */}
        <Route
          path=":group_code/:project_code/standard/item"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcInformationForViewer />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        {/* 가동시간 관리 항목 */}
        <Route
          path=":group_code/:project_code/standard/time"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcFactoryManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/plan"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcPlan />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/bom_management"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcBomManagement />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/material"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcMaterial />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/result/grid"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcresultGrid />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/stock"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcStock />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/custom_settings"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcCustomSettings />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/result/tpc_gantt"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcGantt />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/admin"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcAdmin />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/work_order/work_order"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcWorkOrder />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/work_order/performance"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcWorkOrderLog />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/model_conversion"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcChangeover />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/shift"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcShift />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/sjh_stock_info"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcTempStock />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/standard/stock_info"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <TpcStockInfo />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/simulation"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <Simulation />
              </ProjectGuard>
            </GroupGuard>
          }
        />
        <Route
          path=":group_code/:project_code/work_order/work_order_register"
          element={
            <GroupGuard>
              <ProjectGuard systemType="TPC">
                <WorkOrderRegister />
              </ProjectGuard>
            </GroupGuard>
          }
        />
      </Route>

      {/* /mobile의 하위 페이지 */}
      <Route
        path="/mobile"
        element={
          <ThemeComponent settings={lightSettings}>
            <ProtectedRoute>
              <MobileAppLayout />
            </ProtectedRoute>
          </ThemeComponent>
        }
      >
        {/* <Route index element={<MobileMainPage />} /> */}
        <Route index element={<MobileTempPage />} />
        <Route path="qr" element={<QrPage />} />
        <Route path="qrscan" element={<QrScanPage />} />
        <Route path="checklist" element={<ChecklistPage />} />
      </Route>

      {/* 기타 경로는 랜딩 페이지로 리다이렉트 */}
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}

export default AllRoute;
